import styles from './RemoveModeOverlay.module.css'

/**
 * Remove mode changes the whole screen, not a button. A 3px inset red frame over the
 * entire app tells a gloved operator glancing down that the next scan takes an item
 * off the pallet rather than adding one. It never intercepts taps.
 */
export function RemoveModeOverlay() {
  return <div className={styles.overlay} aria-hidden="true" />
}
